import { UI, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { CardTitle } from '../../../../components/CardTitle';
import { CustomItem } from '../../../../components/CustomItem';
import { HighlightedInfos } from '../../../../components/HighlightedInfos';
import { ColoredInfoSkeleton, InfoItem } from '../../../../components/InfoItem';
import { ProductCard } from '../../../../components/ProductCard';

export interface ValueSelectionStepLoadingProps {
  productName: string;
}

export const ValueSelectionStepLoading: React.FC<ValueSelectionStepLoadingProps> = ({
  productName,
}) => {
  return (
    <ProductCard barColor="product.fundos">
      <VStack space={Spacing['stack.xxxs']}>
        <CardTitle title={productName} />
        <InfoItem label="Resgate Pendente" loading />
        <InfoItem label="Total Bruto" loading />
        <VStack space={Spacing['stack.quarck']} w="full">
          <UI.Text color="neutral.black" variant="semibold">
            Simulador
          </UI.Text>

          <ColoredInfoSkeleton w="full" height="40px" />
        </VStack>
        <CustomItem label="Resgate Total" value={<UI.Switch size="sm" disabled isDisabled />} />
        <HighlightedInfos
          infos={[
            { label: 'IR Previsto', loading: true },
            { label: 'IOF Previsto', loading: true },
            { label: 'Liquido Previsto', loading: true },
          ]}
        />
        <ColoredInfoSkeleton w="full" height="40px" />
        <UI.Button w="full" isDisabled>
          Continuar
        </UI.Button>
      </VStack>
    </ProductCard>
  );
};
